import DateFilter from '@/components/date-filter';
import $ from 'jquery'
import store_article from "@/store/mods/stock/articles"
import Prestation from "@/components/prestations-exploitations/prestation"

export default {
    name: 'stock-sorties',
    components: {
        DateFilter, Prestation
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,

            is_printing: false,
            filename: '',
            can_print: false,
            is_month: false,
            load_error: false,
            liste_sorties: []
        }   
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            const data = {
                is_creance: 0,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.getListeSortieStock(data)
            this.is_month = true
        },
    },

    computed: {

    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getListeSortieStock(data)
    },

    methods: {
        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getListeSortieStock(data)
        },

        getListeSortieStock(data) {
            this.is_loading = true
            this.load_error = false

            store_article.getRecapSortieStock(data).then((response) => {
                this.liste_sorties = response

                if (this.liste_sorties.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false 
            }).catch(() => {
                this.is_loading = false
                this.load_error = true
            })
        }
    }
}